module.exports = __webpack_public_path__ + "img/about_us_hero.381a5ec5.webp";